import React from 'react'
import 'react-toastify/dist/ReactToastify.css';
import { StaticImage } from "gatsby-plugin-image"

const ContactForm = () => {

    const contactForm = `
    <!-- Note :
   - You can modify the font style and form style to suit your website. 
   - Code lines with comments Do not remove this code are required for the form to work properly, make sure that you do not remove these lines of code. 
   - The Mandatory check script can modified as to suit your business needs. 
   - It is important that you test the modified form before going live.-->
<div id='crmWebToEntityForm' class='zcwf_lblLeft crmWebToEntityForm' style='width: 100%;'>
    <meta name='viewport' content='width=device-width, initial-scale=1.0'>
    <META HTTP-EQUIV='content-type' CONTENT='text/html;charset=UTF-8'>
    <form action='https://crm.zoho.com/crm/WebToLeadForm' name=WebToLeads2766946000005649013 method='POST'
        onSubmit='javascript:document.charset="UTF-8"; return checkMandatory2766946000005649013()'
        accept-charset='UTF-8'>
        <input type='text' style='display:none;' name='xnQsjsdp'
            value='91969da047839e04c11caeed617c62ef24865ebe63b80fb1d6284f1dd299d113'></input>
        <input type='hidden' name='zc_gad' id='zc_gad' value=''></input>
        <input type='text' style='display:none;' name='xmIwtLD'
            value='88c267bf398dce3a54849af3d0746b439e14d967aa2d333482b8fbdea7f2f85e'></input>
        <input type='text' style='display:none;' name='actionType' value='TGVhZHM='></input>
        <input type='text' style='display:none;' name='returnURL' value='https&#x3a;&#x2f;&#x2f;dochaseadx.com&#x2f;'>
        </input>
        <!-- Do not remove this code. -->
        <style>
            html,
            body {
                margin: 0px;
            }

            #crmWebToEntityForm.zcwf_lblLeft {
                width: 100%;
                margin: 0 auto;
                box-sizing: border-box;
            }

            #crmWebToEntityForm.zcwf_lblLeft * {
                box-sizing: border-box;
            }

            #crmWebToEntityForm {
                text-align: left;
            }

            #crmWebToEntityForm * {
                direction: ltr;
            }

            .zcwf_lblLeft .zcwf_title {
                word-wrap: break-word;
                font-weight: bold
            }

            .zcwf_lblLeft.cpT_primaryBtn:hover {
                background: linear-gradient(#02acff 0, #006be4 100%) no-repeat padding-box !important;
                box-shadow: 0 -2px 0 0 #0159b9 inset !important;
                border: 0 !important;
                color: #fff !important;
                outline: 0 !important;
            }

            .zcwf_lblLeft .zcwf_col_fld input[type=text],
            input[type=password],
            .zcwf_lblLeft .zcwf_col_fld textarea {
                width: 100%;
                border: 1px solid #c0c6cc !important;
                resize: vertical;
                border-radius: 2px;
                float: left;
            }

            .zcwf_lblLeft .zcwf_col_lab {
                width: 100%;
                word-break: break-word;
                margin-right: 10px;
                margin-top: 5px;
                float: left;
                min-height: 1px;
            }

            .zcwf_lblLeft .zcwf_col_fld {
                float: left;
                width: 100%;
                padding: 0px 6px 0px;
                position: relative;
                margin-top: 5px;
            }

            .zcwf_lblLeft .zcwf_privacy {
                padding: 6px;
            }

            .zcwf_lblLeft .wfrm_fld_dpNn {
                display: none;
            }

            .dIB {
                display: inline-block;
            }

            .zcwf_lblLeft .zcwf_col_fld_slt {
                width: 100%;
                border: 1px solid #ccc;
                background: #fff;
                border-radius: 4px;
                font-size: 14px;
                float: left;
                resize: vertical;
                padding: 8px;
            }

            .zcwf_row {
                display: grid;
            }

            .zcwf_lblLeft .zcwf_row:after,
            .zcwf_lblLeft .zcwf_col_fld:after {
                content: '';
                display: table;
                clear: both;
            }

            .zcwf_lblLeft .zcwf_col_help {
                float: left;
                margin-left: 7px;
                font-size: 14px;
                max-width: 35%;
                word-break: break-word;
            }

            .zcwf_lblLeft .zcwf_help_icon {
                cursor: pointer;
                width: 16px;
                height: 16px;
                display: inline-block;
                background: #fff;
                border: 1px solid #c0c6cc;
                color: #c1c1c1;
                text-align: center;
                font-size: 11px;
                line-height: 16px;
                font-weight: bold;
                border-radius: 50%;
            }

            .zcwf_lblLeft .zcwf_row {
                margin: 15px 0px;
            }

            .zcwf_lblLeft .formsubmit {
                margin-right: 5px;
                cursor: pointer;
                color: var(--baseColor);
                font-size: 14px;
            }

            .zcwf_lblLeft .zcwf_privacy_txt {
                width: 90%;
                color: rgb(0, 0, 0);
                font-size: 14px;
                display: inline-block;
                vertical-align: top;
                color: var(--baseColor);
                padding-top: 2px;
                margin-left: 6px;
            }

            .zcwf_lblLeft .zcwf_button {
                font-size: 14px;
                /* border: 1px solid #c0c6cc; */
                padding: 10px;
                border-radius: 4px;
                cursor: pointer;
                /* max-width: 120px; */
                color: white;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                background-color: rgba(249, 37, 57, 1);
            }

            .zcwf_lblLeft .zcwf_tooltip_over {
                position: relative;
            }

            .zcwf_lblLeft .zcwf_tooltip_ctn {
                position: absolute;
                background: #dedede;
                padding: 3px 6px;
                top: 3px;
                border-radius: 4px;
                word-break: break-word;
                min-width: 100px;
                max-width: 150px;
                color: var(--baseColor);
                z-index: 100;
            }

            .zcwf_lblLeft .zcwf_ckbox {
                float: left;
            }

            .zcwf_lblLeft .zcwf_file {
                width: 55%;
                box-sizing: border-box;
                float: left;
            }

            .clearB:after {
                content: '';
                display: block;
                clear: both;
            }

            @media all and (max-width: 600px) {

                .zcwf_lblLeft .zcwf_col_lab,
                .zcwf_lblLeft .zcwf_col_fld {
                    width: auto;
                    float: none !important;
                }

                .zcwf_lblLeft .zcwf_col_help {
                    width: 40%;
                }
            }

            input {
                padding: 0.375rem;
                background-color: rgba(172, 172, 172, 0.25);
                border-radius: 0.375rem;
                border: none;
            }

            button {
                width: 100%;
            }
        </style>
        <div class='zcwf_row'>
            <div class='zcwf_col_lab' style='font-size:14px; '><label for='First_Name'>First Name<span
                        style='color:red;'>*</span></label></div>
            <div class='zcwf_col_fld'><input type='text' id='First_Name' name='First Name' maxlength='40'></input>
                <div class='zcwf_col_help'></div>
            </div>
        </div>
        <div class='zcwf_row'>
            <div class='zcwf_col_lab' style='font-size:14px;'><label for='Last_Name'>Last
                    Name<span style='color:red;'>*</span></label></div>
            <div class='zcwf_col_fld'><input type='text' id='Last_Name' name='Last Name' maxlength='80'></input>
                <div class='zcwf_col_help'></div>
            </div>
        </div>
        <div class='zcwf_row'>
            <div class='zcwf_col_lab' style='font-size:14px;'><label for='Company'>Company<span
                        style='color:red;'>*</span></label></div>
            <div class='zcwf_col_fld'><input type='text' id='Company' name='Company' maxlength='200'></input>
                <div class='zcwf_col_help'></div>
            </div>
        </div>
        <div class='zcwf_row'>
            <div class='zcwf_col_lab' style='font-size:14px;'><label for='Email'>Email<span
                        style='color:red;'>*</span></label></div>
            <div class='zcwf_col_fld'><input type='text' ftype='email' autocomplete='false' id='Email' name='Email'
                    maxlength='100'></input>
                <div class='zcwf_col_help'></div>
            </div>
        </div>
        <div class='zcwf_row'>
            <div class='zcwf_col_lab' style='font-size:14px;'><label for='Phone'>Phone<span
                        style='color:red;'>*</span></label></div>
            <div class='zcwf_col_fld'><input type='text' id='Phone' name='Phone' maxlength='30'></input>
                <div class='zcwf_col_help'></div>
            </div>
        </div>
        <div class='zcwf_row'>
            <div class='zcwf_col_lab' style='font-size:14px;'><label for='Country'>Country<span
                        style='color:red;'>*</span></label></div>
            <div class='zcwf_col_fld'><input type='text' id='Country' name='Country' maxlength='100'></input>
                <div class='zcwf_col_help'></div>
            </div>
        </div>
        <div class='zcwf_row'>
            <div class='zcwf_col_lab' style='font-size:14px;'><label for='Industry'>Industry<span
                        style='color:red;'>*</span></label></div>
            <div class='zcwf_col_fld'><select class='zcwf_col_fld_slt' id='Industry' name='Industry'>
                    <option value='-None-'>-None-</option>
                    <option value='Agriculture'>Agriculture</option>
                    <option value='Advertising'>Advertising</option>
                    <option value='Digital&#x20;Marketing'>Digital Marketing</option>
                    <option value='Education'>Education</option>
                    <option value='E-Commerce'>Engineering</option>
                    <option value='ManagementISV'>ManagementISV</option>
                    <option value='Fimtech'>Fimtech</option>
                    <option value='FMCG'>FMCG</option>
                    <option value='Health Care'>Health Care</option>
                    <option value='Information&#x20;and&#x20;Technology'>Information and Technology</option>
                    <option value='Real&#x20;Estate'>Real Estate</option>
                    <option value='Others'>Others</option>
                </select>
                <div class='zcwf_col_help'></div>
            </div>
        </div>
        <div class='zcwf_row'>
            <div class='zcwf_privacy'>
                <div class='dIB vat' align='left'>
                    <div class='displayPurpose  f13'><label class='newCustomchkbox-md dIB w100per'><input
                                autocomplete='off' id='privacyTool2766946000005649013' type='checkbox'
                                name='privacyTool' onclick='disableErr2766946000005649013()'></label></div>
                </div>
                <div class='dIB zcwf_privacy_txt' style='font-size: 14px;'>I
                    agree to the Privacy Policy and Terms of Service.</div>
                <div id='privacyErr2766946000005649013'
                    style='font-size:12px;color:red;padding-left: 5px;visibility:hidden;'>Please accept this</div>
            </div>
        </div>
        <div class='zcwf_row'>
            <div class='zcwf_col_lab'></div>
            <div class='zcwf_col_fld'><input type='submit' id='formsubmit' class='formsubmit zcwf_button' value='Submit'
                    title='Submit'>
            </div>
        </div>
        <script>
            function privacyAlert2766946000005649013() {
                var privacyTool = document.getElementById('privacyTool2766946000005649013');
                var privacyErr = document.getElementById('privacyErr2766946000005649013');
                if (privacyTool != undefined && !privacyTool.checked) {
                    privacyErr.style.visibility = 'visible';
                    privacyTool.focus();
                    return false;
                }
                return true;
            }
            function disableErr2766946000005649013() {
                var privacyTool = document.getElementById('privacyTool2766946000005649013');
                var privacyErr = document.getElementById('privacyErr2766946000005649013');
                if (privacyTool != undefined && privacyTool.checked && privacyErr != undefined) {
                    privacyErr.style.visibility = 'hidden';
                }
            }
            function validateEmail2766946000005649013() {
                var form = document.forms['WebToLeads2766946000005649013'];
                var emailFld = form.querySelectorAll('[ftype=email]');
                var i;
                for (i = 0; i < emailFld.length; i++) {
                    var emailVal = emailFld[i].value;
                    if ((emailVal.replace(/^\s+|\s+$/g, '')).length != 0) {
                        var atpos = emailVal.indexOf('@');
                        var dotpos = emailVal.lastIndexOf('.');
                        if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length) {
                            alert('Please enter a valid email address. ');
                            emailFld[i].focus();
                            return false;
                        }
                    }
                }
                return true;
            }

            function checkMandatory2766946000005649013() {
                var mndFileds = new Array('Company', 'First Name', 'Last Name', 'Email', 'Phone', 'Industry', 'Country');
                var fldLangVal = new Array('Company', 'First\x20Name', 'Last\x20Name', 'Email', 'Phone', 'Industry', 'Country');
                for (i = 0; i < mndFileds.length; i++) {
                    var fieldObj = document.forms['WebToLeads2766946000005649013'][mndFileds[i]];
                    if (fieldObj) {
                        if (((fieldObj.value).replace(/^\s+|\s+$/g, '')).length == 0) {
                            if (fieldObj.type == 'file') {
                                alert('Please select a file to upload.');
                                fieldObj.focus();
                                return false;
                            }
                            alert(fldLangVal[i] + ' cannot be empty.');
                            fieldObj.focus();
                            return false;
                        } else if (fieldObj.nodeName == 'SELECT') {
                            if (fieldObj.options[fieldObj.selectedIndex].value == '-None-') {
                                alert(fldLangVal[i] + ' cannot be none.');
                                fieldObj.focus();
                                return false;
                            }
                        } else if (fieldObj.type == 'checkbox') {
                            if (fieldObj.checked == false) {
                                alert('Please accept  ' + fldLangVal[i]);
                                fieldObj.focus();
                                return false;
                            }
                        }
                        try {
                            if (fieldObj.name == 'Last Name') {
                                name = fieldObj.value;
                            }
                        } catch (e) { }
                    }
                }
                if (!validateEmail2766946000005649013()) { return false; }

                if (!privacyAlert2766946000005649013()) { return false; }
                document.querySelector('.crmWebToEntityForm .formsubmit').setAttribute('disabled', true);
            }

            function tooltipShow2766946000005649013(el) {
                var tooltip = el.nextElementSibling;
                var tooltipDisplay = tooltip.style.display;
                if (tooltipDisplay == 'none') {
                    var allTooltip = document.getElementsByClassName('zcwf_tooltip_over');
                    for (i = 0; i < allTooltip.length; i++) {
                        allTooltip[i].style.display = 'none';
                    }
                    tooltip.style.display = 'block';
                } else {
                    tooltip.style.display = 'none';
                }
            }
        </script>
        <!-- Do not remove this --- Analytics Tracking code starts -->
        <script id='wf_anal'
            src='https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=88c267bf398dce3a54849af3d0746b439e14d967aa2d333482b8fbdea7f2f85egid91969da047839e04c11caeed617c62ef24865ebe63b80fb1d6284f1dd299d113gid885e3c1045bd9bdcc91bdf30f82b5696gid14f4ec16431e0686150daa43f3210513&tw=61690b96c1d0471b638f31426f38e68aa67fb7ed6da86f32dc10ad817fe55a0a'></script>
        <!-- Do not remove this --- Analytics Tracking code ends. -->
    </form>
</div>
    `

    return (
        <section className='my-16 lg:my-32 lg:max-w-[1440px] mx-auto'>
            <div className='mx-[6%] lg:mx-[13%]'>
                <p className='text-[#454444] text-2xl lg:text-5xl font-bold'>We love to hear from you!</p>
                <p className='mt-5 text-base lg:text-xl'>Let us handle your next campaign.</p>
                <div className='lg:grid grid-cols-2 space-y-4 lg:space-y-0 mt-2'>
                    <StaticImage
                        src="https://res.cloudinary.com/dt4exd1wa/image/upload/v1696331767/dochaseadx/jl0j3jqjk4c3lajtkbdd.png"
                        alt='form image'
                        className='object-cover'
                        placeholder="blurred"
                        quality="100"
                    />
                    <div className='bg-gradient-to-b from-[#3DBA88] to-[#F02135] p-3 lg:p-7 rounded-r-2xl lg:rounded-r-[35px] w-full'>
                        <div className='bg-white rounded-r-2xl lg:rounded-r-[35px] pt-6 px-11 pb-6 h-full ' dangerouslySetInnerHTML={{ __html: contactForm }}>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactForm